export default [
  {
    path: '/upa',
    component: () => import('@/pages/Upa/Index.vue'),
  },
  {
    path: '/atendimentos-classificacao',
    component: () => import('@/pages/Upa/AtendimentosClassificacao/Index.vue'),
  },
]
